<template>
  <div class="feature-icon-list">
    <div class="row">
      <div class="col-lg-6">
        <div class="feature-icon-list__media wow move-up">
          <img
            src="../assets/SandraSoft/C/IMG_2laptop.png"
            class="img-fluid"
            alt=""
          />
        </div>
      </div>
      <div class="col-lg-6">
        <div class="feature-icon-list__content">
          <div class="feature-icon-list-wrapper">
            <div
              v-for="feature in features"
              :key="feature.id"
              class="single-feature-icon wow move-up"
            >
              <div class="single-feature-icon__media">
                <img
                  :src="feature.icon"
                  class="img-fluid"
                  alt=""
                  style="margin-top: 1rem"
                />
              </div>
              <div class="single-feature-icon__content">
                <h6 class="title">{{ feature.title }}</h6>
                <div class="text">{{ feature.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "featureList",
  data() {
    return {
      features: [
        {
          title: "Effective Healthcare Management",
          icon: require("../assets/img/icons/aeroland-app-showcase-box-icon-image-02.png"),
          desc: "Automate the process of patients admission, medical assessments, billing to financial report",
        },
        {
          icon: require("../assets/img/icons/aeroland-app-showcase-box-icon-image-03.png"),
          title: "Electronic Medical Record",
          desc: "Completely replace the paper works of medical examination",
        },
        {
          icon: require("../assets/img/icons/aeroland-app-showcase-box-icon-image-01.png"),
          title: "AI Assisted Diagnosis",
          desc: "Enhance the diagnosis capability of doctors through AI that originates from effective management of medical data points",
        },
      ],
    };
  },
};
</script>
